export const preset = ['#A51A1A', '#E69327', '#2274B4', '#5BAA00'];
